import { useGetDocumentUsers } from 'pages/documents_v2/hooks/useGetDocumentUsers';

/**
 * @param {string} userId
 * @param {number} [documentId]
 *
 * @returns {import('models/documents.models').DocumentUser | undefined}
 */
export function useGetDocumentUser(userId, documentId) {
    const documentUsers = useGetDocumentUsers(documentId);

    return documentUsers.find((user) => user.userId === userId);
}
